(function (angular) {
  "use strict";

  angular
    .module("app")
    .controller("accountController", ["$scope", "$q", "$http", "$window", "alkModalService", "_", "alkAuthenticationService", "$location", "UserProvider", "Messages", "netSuite", "AccountManagement", "ALKChangePassword", "$filter", "eventTracker",
      function ($scope, $q, $http, $window, alkModalService, _, alkAuthenticationService, $location, userProvider, Messages, netSuite, AccountManagement, ALKChangePassword, $filter, eventTracker) {
        var vm = this;

        vm.isProcessing = false;

        function updateForUser(user) {
          if (user.isLoggedIn === false) {
            return;
          }
          if (user.accountType === "Trial") {
            vm.featureLevel.featureLevel = "Trial";
            vm.featureLevelInfo = vm.featureLevelInfo.filter(feature => {
              return feature.name !== "Standard"
            });
          } else {
            vm.featureLevel.featureLevel = user.subscriptionLevel;

            // for non-trial users, don't let them go back to a Trial account

            vm.featureLevelInfo = vm.featureLevelInfo.filter(feature => {
              return vm.featureLevel.featureLevel === "Premium" ? feature.name === "Premium" : feature.name !== "Trial";
            });
          }
        }

        function getPaymentInfo() {
          // if user is not admin, or if netSuite is down, do not try to get payment info
          if (!userProvider.getUser().isAdmin() || !userProvider.getUser().netSuiteOnline) return $q.when();

          var deferred = $q.defer();

          netSuite.getPaymentInformation()
            .then(function (paymentInformation) {
              vm.billing = paymentInformation.billing;
              vm.creditCard = paymentInformation.credit;

              originalBilling = angular.copy(vm.billing);
              vm.originalCreditCard = angular.copy(vm.creditCard);

              deferred.resolve();
            });

          return deferred.promise;
        }

        function shouldSubmitBillingAddress() {
          // if the billing has been updated or if there was no billing to start with, we need to send it.
          var isBillingUpdated = !angular.equals(vm.billing, originalBilling);
          return isBillingUpdated || originalBilling == null;
        }

        function shouldSubmitFeatureLevel() {
          var isFeatureLevelUpdated = !angular.equals(vm.featureLevel, originalFeatureLevel);
          return isFeatureLevelUpdated;
        };

        var originalBilling = {};
        vm.originalCreditCard = {};
        var originalFeatureLevel = {};

        vm.newUserFormVisible = false;

        vm.account = {};
        vm.featureLevelInfo = [{
          "name": "Trial",
          "cost": 0
        }, {
          "name": "Standard",
          "cost": 59.99
        }, {
          "name": "Premium",
          "cost": 84.99
        }];
        vm.featureLevelCost = function () {
          if (!_.isUndefined(vm.featureLevel.featureLevel)) {
            return _.find(vm.featureLevelInfo, {
              "name": vm.featureLevel.featureLevel
            }).cost;
          } else {
            return "";
          }
        };
        vm.newUser = {};

        vm.loginInfo = {};
        vm.featureLevel = {};
        vm.billing = {};
        vm.creditCard = {};

        vm.usersCurrentPage = 1;

        vm.usersPerPage = 10;

        vm.usersPageChanged = function () {
          if (userProvider.getUser().isAdmin() !== true) {
            return;
          }

          var pagingParam = {
            Count: vm.usersPerPage,
            Skip: (vm.usersCurrentPage - 1) * vm.usersPerPage
          };

          AccountManagement.getUsers({
            params: pagingParam
          }).then(function (resp) {
            vm.usersTotalCount = resp.total;
            vm.account.users = resp.users;
          });
        };

        // have separate submit functions for each section of information so we can only submit the sections we need to and not validate the entire outer form
        vm.shouldSubmitCreditCard = function () {
          if (vm.originalCreditCard == null) return true;
          if (userProvider.getUser().hasBillingIssue == true) return true;

          var number = vm.originalCreditCard.number || "";
          var name = vm.originalCreditCard.name || "";
          var expMonth = vm.originalCreditCard.expMonth || "";
          var expYear = vm.originalCreditCard.expYear || "";
          var cvv = vm.originalCreditCard.cvv || "";
          var hash = number + "_" + name + "_" + expMonth + "_" + expYear + "_" + cvv;

          // the credit card should be required if the user does not currently have a card on file (vm.originalCreditCard is null) or if the the card has been modified (check each of the fields)
          return hash !== vm.creditCardDirty;
        };

        vm.cancelCustomer = function () {
          var message = "Are you sure that you want to cancel your account? Your access to the account will be disabled immediately.";
          if (userProvider.getUser().accountType !== "Trial") {
            message += " Please note that no refund will be issued.";
          }

          alkModalService.show({
            size: "md",
            templateUrl: "/app/account/cancelCustomer.template.html",
            controller: "cancelAccountController as vm",
            resolve: {
              message: function () {
                return message;
              }
            }
          }).then(result => {
            alkAuthenticationService.logout();
            $location.url("/");
            eventTracker.track(eventTracker.EVENTS.CANCEL_ACCOUNT, { featureLevel: vm.featureLevel.featureLevel });
          });
        };

        vm.deleteUser = function (user) {
          $http.post("/api/ManageAccount/DisableUser", {
              email: user.UserName
            })
            .success(function () {
              var indexOf = _.indexOf(vm.account.users, user);
              if (indexOf >= 0) {
                vm.account.users.splice(indexOf, 1);
                vm.usersTotalCount = vm.usersTotalCount - 1;

                // handle the edge case where we are on the last page of results and we delete the only user on that page.  should than change the page we are on.
                var lastPage = Math.ceil(vm.usersTotalCount / vm.usersPerPage);

                if (vm.usersCurrentPage > lastPage) {
                  vm.usersCurrentPage = lastPage;
                }

                vm.usersPageChanged();
              }
            });
        };

        vm.replaceUser = function (user) {
          //display popup to allow the user to replace this user.
          alkModalService.show({
            size: "md",
            templateUrl: "/app/account/replaceUser.template.html",
            controller: "replaceUserController as vm",
            resolve: {
              isReplacingCurrent: function () {
                return user.UserName == userProvider.getUser().userName
              },
              oldUser: function () {
                return user;
              }
            }
          }).then(function () {
            //if user is replacing them self, log out, otherwise, refresh the users list
            if (user.UserName == userProvider.getUser().userName) {
              alkAuthenticationService.logout();
              $location.url("/");
            } else {
              // repopulate the list of users since the person was changed.
              vm.usersPageChanged();
            }
          });
        };

        vm.toggleNewUserForm = function () {
          vm.newUserFormVisible = !vm.newUserFormVisible;

          if (vm.newUserFormVisible === false) {
            vm.newUser.firstName = "";
            vm.newUser.lastName = "";
            vm.newUser.email = "";
          }
        };

        vm.submitNewUser = function (user) {
          Messages.clear();
       
          if (!user) return;
          user.email = user.email.toLowerCase();
          vm.isProcessing = true;

          var newUser = {
            Email: user.email,
            FirstName: user.firstName,
            LastName: user.lastName
          };
        
          AccountManagement.addUser(newUser)
            .then(function () {
              vm.usersTotalCount++;
              vm.featureLevel.newNumberOfUsers = vm.featureLevel.newNumberOfUsers = vm.featureLevel.newNumberOfUsers >= userProvider.getUser().maxNumberOfUsers ? userProvider.getUser().maxNumberOfUsers : vm.featureLevel.newNumberOfUsers + 1 ;
              // currently, vm.account.users only has a single page of users, so we store the total count in a separate property.
              vm.newUser = {};

              if (userProvider.getUser().maxNumberOfUsers - vm.usersTotalCount < 1) {
                // if no more users are available, toggle this form closed.
                vm.newUserFormVisible = false;
                vm.newUser.firstName = "";
                vm.newUser.lastName = "";
                vm.newUser.email = "";
              }

              vm.usersPageChanged();
            })
            .finally(function () {
              vm.isProcessing = false;
            });
        };

        vm.toggleAdminRole = function (user) {
          Messages.clear();

          var originalIsAdmin = !user.isAdmin; // at this point, the bound variable is already changed so it's the opposite.
          var toggleAccess = {
            userName: user.UserName,
            addRole: user.RoleName !== "Company Administrator"
          };

          user.isProcessing = true;

          AccountManagement.changeUserRole(toggleAccess)
            .then(function () {
              if (toggleAccess.addRole) {
                user.RoleName = "Company Administrator";
              } else {
                user.RoleName = "User";
              }
              user.isProcessing = false;
              Messages.add("success", "Successfully updated user's role.", {
                showOnNextPage: false
              });
            }, function (err) {
              user.isAdmin = originalIsAdmin;
              user.isProcessing = false;
              Messages.add("danger", "Error while changing user's role.", {
                showOnNextPage: false
              });
            });
        };

        vm.init = function () {
          vm.usersPageChanged();

          vm.loadingAccount = true;
          vm.loadingPayment = true;

          updateForUser(userProvider.getUser());
          vm.featureLevel.newNumberOfUsers = userProvider.getUser().maxNumberOfUsers;
          originalFeatureLevel = angular.copy(vm.featureLevel);
          getPaymentInfo()
            .finally(function () {
              vm.loadingAccount = false;
              vm.loadingPayment = false;
            });
        };

        vm.submitAccountFeatures = function () {
          Messages.clear();
          var accountFeatures = {};

          accountFeatures.isBillingUpdated = shouldSubmitBillingAddress();
          accountFeatures.isFeatureLevelUpdated = shouldSubmitFeatureLevel();
          accountFeatures.isCreditCardUpdated = vm.shouldSubmitCreditCard();

          if (!accountFeatures.isBillingUpdated && !accountFeatures.isFeatureLevelUpdated && !accountFeatures.isCreditCardUpdated) return;

          vm.isSubmittingAccountFeatures = true;
          vm.isProcessing = true;

          if (accountFeatures.isBillingUpdated) {
            accountFeatures.billing = {
              address1: vm.billing.address1,
              address2: vm.billing.address2,
              city: vm.billing.city,
              state: vm.billing.state,
              zip: vm.billing.postalCode,
              country: vm.billing.country,
              phoneNumber: vm.billing.phoneNumber
            };
          }

          if (accountFeatures.isCreditCardUpdated) {
            accountFeatures.credit = {
              cardHolderName: vm.creditCard.name,
              expirationYear: vm.creditCard.expYear,
              expirationMonth: vm.creditCard.expMonth,
              cardNumber: vm.creditCard.number,
              cardType: vm.creditCard.type,
              cvv: vm.creditCard.cvv
            };
          }

          accountFeatures.featureLevel = {
            featureLevel: vm.featureLevel.featureLevel,
            numberOfUsers: vm.featureLevel.newNumberOfUsers
          };

          $http.post("/api/ManageAccount/UpdateAccountFeatures", accountFeatures)
            .success(response => {
              if (accountFeatures.isBillingUpdated) {
                Messages.add("success", "Successfully updated billing address", {
                  showOnNextPage: false
                });

                eventTracker.track(eventTracker.EVENTS.UPDATE_BILLING, {
                  ogCity: originalBilling.city,
                  newCity: accountFeatures.billing.city,
                  ogState: originalBilling.state,
                  newState: accountFeatures.billing.state
                });

                originalBilling = angular.copy(vm.billing);
              }

              if (accountFeatures.isCreditCardUpdated) {
                Messages.add("success", "Successfully updated credit card", {
                  showOnNextPage: false
                });
                vm.creditCard = response.credit;
                vm.originalCreditCard = angular.copy(response.credit);
              }

              if (accountFeatures.isFeatureLevelUpdated) {
                Messages.add("success", "Successfully updated feature level", {
                  showOnNextPage: false
                });

                eventTracker.track(eventTracker.EVENTS.UPDATE_SUB_LEVEL, {
                  ogFL: originalFeatureLevel.featureLevel,
                  newFL: vm.featureLevel.featureLevel
                });

                vm.featureLevel.newNumberOfUsers = response.User.maxNumberOfUsers;
                originalFeatureLevel = angular.copy(vm.featureLevel);
              }

              userProvider.loadUser(response.User);
              updateForUser(response.User);

              console.log("Finished submit billing address");
            })
            .error(err => {
              if (typeof err === "string") Messages.add("danger", err, {
                showOnNextPage: false
              });
            })
            .finally(() => {
              vm.isProcessing = false;
              vm.isSubmittingAccountFeatures = false;
            });

        };
      }
    ]);
})(window.angular);



// WEBPACK FOOTER //
// ./app/account/account.controller.js